import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfTableDto from '../dto/WhatIfTableDto';

class WhatIfTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<WhatIfTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, WhatIfTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} name
	 * @return {Promise<EntityValidationResult>}
	 */
	copy(id, name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/copy`, {
					id,
					name
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new WhatIfTableService();
